import { render, staticRenderFns } from "./exchange-coin.vue?vue&type=template&id=be4b829c&scoped=true&"
import script from "./exchange-coin.vue?vue&type=script&lang=ts&"
export * from "./exchange-coin.vue?vue&type=script&lang=ts&"
import style0 from "./exchange-coin.vue?vue&type=style&index=0&id=be4b829c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4b829c",
  null
  
)

export default component.exports